import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
//import { SplashScreen } from '@capacitor/splash-screen';
import { MenuController } from '@ionic/angular';
import { App } from '@capacitor/app';
import { ApirestService } from './apirest.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  paymentHandler: any = null;
  public user = '';
  public username = '';
  public appPages = [];
  public appPages2 = [];
  public labels = [];
  public logged: string | null = null;
  public split_pane: any = '';
  public quantity = '';
  showChat = true;

  constructor(
    private router: Router,
    private menuController: MenuController,
    private service: ApirestService,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showChat = !['/login','/register'].includes(event.urlAfterRedirects);
      }
    });
  }

  async ngOnInit() {
    //this.showSplash();

    //this.router.events.subscribe((event) => {
    /* if (event instanceof NavigationEnd  &&
        //event.urlAfterRedirects === "/home"
        event.urlAfterRedirects.startsWith("/home")
      ) {
      } */

    this.router.events.subscribe((event) => {
      if (
        event instanceof NavigationEnd &&
        event.urlAfterRedirects === '/home'
        //event.urlAfterRedirects.startsWith("/home")
      ) {
        const token = localStorage.getItem('token');

        if (!token || this.service.isTokenExpired(token)) {
          //localStorage.setItem('logged', '');
          //this.router.navigate(['/login']);
          this.logoOut();
          return;
        }

        var dataUser = localStorage.getItem('user');
        var email = localStorage.getItem('username');
        this.logged = localStorage.getItem('logged');
        const isDesktop = window.innerWidth > 600;

        if (this.logged === 'true') {
          console.log('logged t', this.logged);
          document.body.classList.add('logged-in');
          //this.split_pane = true;
          if (isDesktop) {
            this.split_pane = true;
          } else {
            this.split_pane = '';
          }
        } else {
          console.log('logged f', this.logged);
          document.body.classList.remove('logged-in');
          this.split_pane = false;
        }

        console.log('datatat');
        console.log(dataUser);

        if (dataUser) {
          this.user = dataUser;
          this.username = email;
        }

        this.quantity = localStorage.getItem('savedServices');
        this.getAppPages();
      }
    });

    this.router.events.subscribe((event) => {
      if (
        event instanceof NavigationEnd &&
        event.urlAfterRedirects === '/savedOrders'
      ) {
        this.quantity = localStorage.getItem('savedServices');
        this.getAppPages();
      }
    });

    //});
    //this.invokeStripe();
    this.checkAppLaunchUrl();
  }

  /* ngAfterViewInit() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `
      (function() {
         
    const customStyle = {
        marginRight: '1rem',
        marginBottom: '6rem',
        display: 'none',
        position: 'fixed',
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        overflow: 'hidden',
        height: '65vh',
        border: '2px solid #e2e8f0',
        borderRadius: '0.375rem',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        width: '30rem'
    };

    // Create widget HTML
    const widgetContainer = document.getElementById('openassistantgpt-widget');
    widgetContainer.innerHTML = \`
  <iframe
      src="https://openassistantgpt.io/embed/cmiqkd2940001sdkz5eau613c/agent-button?chatbox=false"
      scrolling="no"
      title="OpenAssistantGPT Button"
      id="openassistantgpt-chatbot-button-iframe"
      style="position: fixed; bottom: 0; right: 0; margin-bottom: 1rem; z-index: 50; margin-right: 1rem; width: 3.5rem; height: 3.5rem; border: 1px solid #d1d5db; border-radius: 50%; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);"
  ></iframe>

  <iframe
      src="https://openassistantgpt.io/embed/cmiqkd2940001sdkz5eau613c/agent-window?chatbox=false&withExitX=true"
      allowfullscreen
      title="OpenAssistantGPT Window"
      id="openassistantgpt-chatbot-iframe"
      style="margin-right: 1rem; margin-bottom: 6rem; display: none; position: fixed; right: 0; bottom: 0; pointer-events: none; overflow: hidden; height: 65vh; border: 2px solid #e2e8f0; border-radius: 0.375rem; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06); width: 30rem; z-index: 50;"
  ></iframe>
\`;


    // Handle messages between iframes
    window.addEventListener('message', function (event) {
        var iframe = document.getElementById('openassistantgpt-chatbot-iframe');
        var buttonIframe = document.getElementById('openassistantgpt-chatbot-button-iframe');

        if (event.data === 'openChat') {
            if (iframe && buttonIframe) {
                iframe.contentWindow.postMessage('openChat', '*');
                buttonIframe.contentWindow.postMessage('openChat', '*');
                iframe.style.pointerEvents = 'auto';
                iframe.style.display = 'block';
                
                // Responsive design for mobile
                if (window.innerWidth < 640) {
                    iframe.style.position = 'fixed';
                    iframe.style.width = '100%';
                    iframe.style.height = '100%';
                    iframe.style.top = '0';
                    iframe.style.left = '0';
                    iframe.style.zIndex = '9999';
                } else {
                    iframe.style.position = 'fixed';
                    iframe.style.width = '30rem';
                    iframe.style.height = '65vh';
                    iframe.style.bottom = '0';
                    iframe.style.right = '0';
                    iframe.style.top = '';
                    iframe.style.left = '';
                }
            }
        }

        if (event.data === 'closeChat') {
            if (iframe && buttonIframe) {
                iframe.style.display = 'none';
                iframe.style.pointerEvents = 'none';
                iframe.contentWindow.postMessage('closeChat', '*');
                buttonIframe.contentWindow.postMessage('closeChat', '*');
            }
        }
    });
      })();
    `;
    document.body.appendChild(script);
  } */

  /* ngAfterViewInit() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `
      (function() {
        // Estilo para el iframe del chat window
        const customStyle = "margin-right: 1rem; margin-bottom: 6rem; display: none; position: fixed; right: 0; bottom: 0; pointer-events: none; overflow: hidden; height: 65vh; border: 2px solid #e2e8f0; border-radius: 0.375rem; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06); width: 480px; z-index: 50;";

        const widgetContainer = document.getElementById('openassistantgpt-widget');
        widgetContainer.innerHTML = \`
          <!-- Button iframe -->
          <iframe
            src="https://www.openassistantgpt.io/embed/cmirluhuk0009zj9r6zhhu6kk/button?chatbox=false"
            scrolling="no"
            title="OpenAssistantGPT Button"
            id="openassistantgpt-chatbot-button-iframe"
            style="position: fixed; bottom: 0; right: 0; margin-bottom: 1rem; margin-right: 1rem; width: 60px; height: 60px; border: 2px solid #e2e8f0; border-radius: 50%; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06); z-index: 50;"
          ></iframe>

          <!-- Chat window iframe -->
          <iframe
            src="https://www.openassistantgpt.io/embed/cmirluhuk0009zj9r6zhhu6kk/window?chatbox=false&withExitX=true"
            allowfullscreen
            allow="clipboard-read; clipboard-write"
            title="OpenAssistantGPT Window"
            id="openassistantgpt-chatbot-iframe"
            style="\${customStyle}"
          ></iframe>
        \`;

        // Manejo de mensajes entre los iframes
        window.addEventListener('message', function(event) {
          const iframe = document.getElementById('openassistantgpt-chatbot-iframe');
          const buttonIframe = document.getElementById('openassistantgpt-chatbot-button-iframe');

          if (event.data === 'openChat') {
            if (iframe && buttonIframe) {
              iframe.contentWindow.postMessage('openChat', '*');
              buttonIframe.contentWindow.postMessage('openChat', '*');
              iframe.style.pointerEvents = 'auto';
              iframe.style.display = 'block';

              // Responsive para móviles
              if (window.innerWidth < 640) {
                iframe.style.position = 'fixed';
                iframe.style.width = '100%';
                iframe.style.height = '100%';
                iframe.style.top = '0';
                iframe.style.left = '0';
                iframe.style.zIndex = '9999';
              } else {
                iframe.style.position = 'fixed';
                iframe.style.width = '480px';
                iframe.style.height = '65vh';
                iframe.style.bottom = '0';
                iframe.style.right = '0';
                iframe.style.top = '';
                iframe.style.left = '';
              }
            }
          }

          if (event.data === 'closeChat') {
            if (iframe && buttonIframe) {
              iframe.style.display = 'none';
              iframe.style.pointerEvents = 'none';
              iframe.contentWindow.postMessage('closeChat', '*');
              buttonIframe.contentWindow.postMessage('closeChat', '*');
            }
          }
        });
      })();
    `;
    document.body.appendChild(script);
  } */

  getAppPages() {
    this.appPages = [
      /* { title: 'Inicio', url: '/home/', icon: 'home' }, */
      //{ title: `CUSTOMER'S DASHBOARD`, subtitle :'dashboard' },
      /* {
        title: 'PROFILE', url: '/sync/',
        children: [
          { title: `${this.user}`, url: '/sync/' },
          { title: `${this.username}`, url: '/sync/' },
        ]
      }, */

      {
        title: 'ACCOUNT',
        //url: "/sync/",
        children: [
          { title: 'My profile ', url: '/myProfile/' },
          { title: 'My payment methods ', url: '/myPayments/' },
          { title: 'Change my password  ', url: '/changePassword/' },
        ],
      },
      { title: `SAVED ORDERS (${this.quantity})`, url: '/savedOrders/' },
      { title: 'UPDATES (0)' },
      //{ title: 'RATE YOUR SERVICE', url: '/sync/', },
      { title: 'PRE-SCHEDULE (0)' },
      {
        title: 'HISTORY',
        //url: "/sync/",
        children: [
          { title: 'See all history requests ', url: '/servicesHistory/' },
        ],
      },
      {
        title: 'RUNNING ORDERS (0)',
        //url: "/ongoingService/",
        children: [
          { title: 'Check status', url: '/checkStatus/' },
          { title: 'Make changes' },
        ],
      },
      {
        title: 'FEE CALCULATIONS',
        url: '/courierFees/',
        /* children: [
          { title: 'Courier fees', url: '/courierFees/' },
          { title: 'Calculation fees', url: '/calculationFees/' },
        ] */
      },
      { title: 'LOST & FOUND', url: '/lostFound/' },
      { title: 'SAFETY', url: '/safety/' },
      { title: 'CONTACT US', url: '/contactUs/' },
      { title: 'LOG OUT', url: '/login/' },
    ];
  }

  /* invokeStripe() {
    if (!window.document.getElementById("stripe-script")) {
      const script = window.document.createElement("script");
      script.id = "stripe-script";
      script.type = "text/javascript";
      script.src = "https://checkout.stripe.com/checkout.js";
      script.onload = () => {
        this.paymentHandler = (<any>window).StripeCheckout.configure({
          //key: 'pk_test_51M3T5fKOplobDjkm3betuQ16yPq3bw0JA5LoKV6GaKdnAan6xE8bZ2db0CrdvdsAU8bFXw02SXZRiEWnOXRkjC9A00ylk3zZGT',
          key: "pk_test_51MRp2OD2zVFXFkpBt4OBDZU7GSw5bod3CmslOZdN98S365Q80cRfz6Qubqqvlq9OMgXBJwCmMr7MUbfcWb2eun7j008XGfyzmC",
          locale: "auto",
          token: function (stripeToken: any) {
            console.log(stripeToken);
            alert("Payment has been successfull!");
          },
        });
      };
      window.document.body.appendChild(script);
    }
  }
 */
  logoOut() {
    localStorage.setItem('token', '');
    localStorage.setItem('user', '');
    localStorage.setItem('username', '');
    localStorage.setItem('rol_user', '');
    localStorage.setItem('param', '');
    localStorage.setItem('logged', '');
    localStorage.setItem('savedServices', '');
    localStorage.setItem('chatPosition', '');
    this.split_pane = false;
    setTimeout(() => {
      this.closeMenu();
    }, 500);
  }

  /*  async showSplash(){
    await SplashScreen.show({
      autoHide: true,
      showDuration: 2000,
    });
  } */

  closeMenu() {
    console.log('ingreso a cerrar menu');
    this.menuController.isOpen().then((isOpen) => {
      console.log('isOpen menu', isOpen);
      if (isOpen) {
        this.menuController.close();
      }
    });
  }

  async checkAppLaunchUrl() {
    App.addListener('appStateChange', ({ isActive }) => {
      console.log('App state changed. Is active?', isActive);
    });

    App.addListener('appUrlOpen', ({ url }) => {
      if (url) {
        console.log('App opened with URL:', url);

        if (url.includes('services')) {
          console.log('redirect services');
          const service_id = url.split('/')[3];
          console.log('serviceId ', service_id);
          this.router.navigate([`/services/${service_id}`]);
        } else if (url.includes('home')) {
          console.log('redirect home');
        }
      }
    });

    App.addListener('appRestoredResult', (data) => {
      console.log('Restored state:', data);
    });
  }
}
